// @flow
import React from 'react';
import OptionRenderer, {
  type BaseOptionRendererProps,
} from './option-renderers/';
import type {ValidationError} from '../types/productOptions';

type Props = BaseOptionRendererProps & {
  validationErrors: ValidationError[],
};

export default function ProductOptionsRenderer(props: Props) {
  return <OptionRenderer {...props} />;
}
